'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('createaccount', {
      url: '/new/user/account',
      template: '<createaccount></createaccount>'
    })
    .state('createaccount.success', {
      views: {
          'create-content': {
              template: require('./templates/createaccount.success.html'),
              controller: 'createaccountCtrl',
              controllerAs: 'createCtrl'
          }
      },
      url: '/success'

  });
}



// WEBPACK FOOTER //
// ./client/app/account/createaccount/createaccount.routes.js